import i18n from "@microdoing/shared/i18n";
import {
  Box,
  MainCard,
  MainText,
  PressableOpacity,
} from "app/components/common";
import ArrowUp from "app/components/Icons/Arrow/ArrowUp";
import theme from "app/Theme/Theme";
import React from "react";

const AllowNotificationCard = ({ onPressAuthorize, onPressReject }) => {
  return (
    <Box flex={1} width="100%" alignItems="center" justifyContent="center">
      <MainCard
        variant="cardAllowNotification"
        width="90%"
        alignSelf="center"
        padding="null"
      >
        <MainText variant="l4-medium" textAlign="center" margin="xm">
          {i18n.t("microdoing-allow-notifications")}
        </MainText>
        <Box borderColor="neutral.300" borderBottomWidth={1} width="100%" />
        <Box
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          height={50}
        >
          <PressableOpacity
            style={{
              flex: 1,
              height: "100%",
              justifyContent: "center",
            }}
            onPress={onPressReject}
          >
            <MainText variant="l4-medium" textAlign="center">
              {i18n.t("reject")}
            </MainText>
          </PressableOpacity>
          <Box borderColor="neutral.300" borderLeftWidth={1} height="100%" />
          <PressableOpacity
            style={{ flex: 1, height: "100%", justifyContent: "center" }}
            onPress={onPressAuthorize}
          >
            <MainText variant="l5-bold" color="brand.500" textAlign="center">
              {i18n.t("allow")}
            </MainText>
          </PressableOpacity>
        </Box>
      </MainCard>
      <Box marginTop="m" width="90%" alignItems="flex-end">
        <Box width="50%" alignItems="center" flexDirection="column">
          <ArrowUp width={30} height={30} color={theme.colors["brand.500"]} />
        </Box>
      </Box>
    </Box>
  );
};

export default AllowNotificationCard;
